import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid, useMediaQuery } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import GreenDot from './icons/GreenDot'
import CopilotSettingsTooltip from './CopilotSettingsTooltip'

const useStyles = makeStyles(theme => ({
  copilotSettingItem: {
    width: ({ isSmallScreen }) => (isSmallScreen ? '180px' : '200px'),
    height: 80,
    backgroundColor: 'rgba(242, 244, 255, 1)',
    padding: 12,
    borderRadius: 16,
    position: 'relative',
    cursor: 'pointer'
  },
  summaryLabel: {
    color: 'rgba(138, 153, 182, 1)',
    maxWidth: '170px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  greenDot: {
    position: 'absolute',
    top: 10,
    right: 10
  }
}))

/**
 *
 * @param {Object} props
 * @param {JSX.Element} props.icon - The icon to display.
 * @param {string} props.title - The title of the setting item.
 * @param {string} [props.summary] - The summary text to display.
 * @param {function} props.onClick - The function to call when the item is clicked.
 * @param {CopilotSettingsCategory} [props.categoryData] - The data for the category, used for the tooltip.
 */
const CopilotSettingItem = ({ icon, title, summary, onClick, categoryData = {} }) => {
  const ref = useRef()
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  const isSmallScreen = useMediaQuery('(max-width:1500px)')
  const classes = useStyles({ isSmallScreen })

  return (
    <Grid
      container
      onClick={onClick}
      className={classes.copilotSettingItem}
      onMouseEnter={() => setIsTooltipOpen(true)}
      onMouseLeave={() => setIsTooltipOpen(false)}
      ref={ref}
    >
      <CopilotSettingsTooltip
        anchorEl={ref.current}
        categoryData={categoryData}
        isOpen={isTooltipOpen}
        onViewPatientSettings={onClick}
      />
      <div className={classes.greenDot}>
        <GreenDot />
      </div>
      <Grid item xs={12}>
        <IconAndText icon={icon} text={<DazzedParagraph14 strong>{title}</DazzedParagraph14>} />
      </Grid>
      {summary && (
        <Grid item xs={12}>
          <DazzedParagraph14 className={classes.summaryLabel}>{summary}</DazzedParagraph14>
        </Grid>
      )}
    </Grid>
  )
}

export default CopilotSettingItem
